import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { applicationNotesKey } from '@features/applicationNotes';
import { applicationNotesRoute } from '@features/applicationNotes/api/constants';
import { employerApplicationsKey, errorMessage } from '@features/applications';
import axiosInstance from '@server/axiosInstance';

type UseCreateApplicationNoteProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useCreateApplicationNote = ({
  setErrorText = () => {},
}: UseCreateApplicationNoteProps) => {
  const client = useQueryClient();

  const { mutate: createNote, isLoading: isCreateNoteLoading } = useMutation({
    mutationFn: (variables: {
      application_id: number;
      note: string;
      name: string;
    }) =>
      axiosInstance
        .post(applicationNotesRoute, variables)
        .then((res) => res.data),
    onSuccess: (data, variables) => {
      client.invalidateQueries([applicationNotesKey, variables.application_id]);
    },
    onError: () => {
      setErrorText(errorMessage);
    },
  });

  return {
    createNote,
    isCreateNoteLoading,
  };
};
